import React from "react";
import { ago, utcLabel } from "./ui";

export const ACTIONS = [
  { key: "confirm-traffic", label: "Confirm traffic", busyLabel: "Confirming traffic…", primary: true },
  { key: "confirm-conversion", label: "Confirm conversion", busyLabel: "Confirming conversion…", primary: true },
  { key: "sync-statuses", label: "Sync statuses", busyLabel: "Syncing statuses…", primary: false },
];

const ReloadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M20 11a8 8 0 1 0-2.3 5.7" />
    <path d="M20 4v7h-7" />
  </svg>
);

export default function Header({ generatedAt, date, onDateChange, onReload, busy, onAction, actions, loading }) {
  const SHORT = { "confirm-traffic": "Traffic", "confirm-conversion": "Conversion", "sync-statuses": "Sync" };
  const lastRuns = (actions || [])
    .map((a) => {
      const last = a.last_runs && a.last_runs[0];
      if (!last) return null;
      return {
        key: a.action, failed: last.status !== "SUCCESS",
        text: `${SHORT[a.action] || a.label} ${last.status === "SUCCESS" ? "" : "failed "}${ago(last.finished_at)}`
      };
    })
    .filter(Boolean);

  return (
    <div className="ams-top">
      <div>
        <h1 className="ams-title">Marketing Stream</h1>
        <div className="ams-scope">
          All managed stores, times in UTC
          <span className="ams-asof">
            {generatedAt ? `Data as of ${utcLabel(generatedAt)} (${ago(generatedAt)})` : "Loading…"}
          </span>
        </div>
      </div>
      <div className="ams-top-right">
        <div className="ams-btns">
          <button type="button" className="ams-btn ams-btn--icon" onClick={() => onReload(true)}
            disabled={loading} title="Reload numbers" aria-label="Reload numbers">
            <ReloadIcon />
          </button>
          {ACTIONS.map((a) => (
            <button key={a.key} type="button" className={`ams-btn${a.primary ? " ams-btn--primary" : ""}`}
              disabled={!!busy[a.key]} onClick={() => onAction(a.key)}>
              {busy[a.key] ? (
                <>
                  <span className="ams-spin" aria-hidden="true" />
                  {a.busyLabel}
                </>
              ) : (
                a.label
              )}
            </button>
          ))}
        </div>
        <div className="ams-subbar">
          {lastRuns.length > 0 && (
            <div className="ams-lastruns">
              Last run
              {lastRuns.map((l) => (
                <span key={l.key} className={l.failed ? "ams-why--red" : ""}>{l.text}</span>
              ))}
            </div>
          )}
          <label className="ams-dayline">
            Day (UTC)
            <input type="date" value={date} onChange={(e) => e.target.value && onDateChange(e.target.value)} />
          </label>
        </div>
      </div>
    </div>
  );
}
